// extracted by mini-css-extract-plugin
export default {"wrapper":"HCjM1","icon":"t9usE","content":"iIPl4","errors":"NsNiz"};